module.exports = __webpack_public_path__ + "media/logos/stripe-06925bce.png";